import { Label, LabelColor } from '@shared/components';

export type ProctorRequestStatusLabelVariant = 'draft' | 'in-review' | 'rejected' | 'approved';

interface ProctorRequestStatusLabelProps {
  variant: ProctorRequestStatusLabelVariant;
}

const PROCTOR_REQUEST_STATUS_COLOR: Readonly<Record<ProctorRequestStatusLabelVariant, LabelColor>> =
  {
    draft: LabelColor.INFO,
    'in-review': LabelColor.WARNING,
    rejected: LabelColor.ERROR,
    approved: LabelColor.SUCCESS,
  };

const PROCTOR_REQUEST_STATUS_TEXT: Readonly<Record<ProctorRequestStatusLabelVariant, string>> = {
  draft: 'แบบร่าง',
  'in-review': 'อยู่ระหว่างอนุมัติ',
  rejected: 'ไม่อนุมัติ',
  approved: 'อนุมัติ',
};

export default function ProctorRequestStatusLabel(props: Readonly<ProctorRequestStatusLabelProps>) {
  const { variant } = props;

  return (
    <Label
      sx={{ px: (theme) => theme.spacing(3) }}
      color={PROCTOR_REQUEST_STATUS_COLOR[variant]}
      variant='outlined'
    >
      {PROCTOR_REQUEST_STATUS_TEXT[variant]}
    </Label>
  );
}
